import { Controller, useFormContext } from 'react-hook-form';
import { PRO_RATA_SETTINGS } from '../../CreatePlanForm/create-plan-form-types/create-plan-form-sub-types';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { VySwitchRow } from '@vy/ui-design-system';

type ProductFieldPrefix = 'fixedProducts' | 'usageProducts' | 'promotionProducts';

type CalendarAlignmentSwitchProps = {
  fieldNamePrefix: ProductFieldPrefix;
  productIndex: number;
};

export const CalendarAlignmentSwitch: React.FC<CalendarAlignmentSwitchProps> = ({
  fieldNamePrefix,
  productIndex,
}) => {
  const { control, setValue, watch } = useFormContext<PlanInputForm>();

  const proRataSetting = watch('proRataSetting');

  return (
    <Controller
      control={control}
      name={`${fieldNamePrefix}.${productIndex}.isCalendarAligned`}
      render={({ field }) => (
        <VySwitchRow
          checked={field.value}
          onBlur={field.onBlur}
          title="Align to calendar month"
          description="Sync billing to calendar dates (e.g. 1st of month) and adjust charges for partial periods"
          data-field-span="full"
          data-vy="plan-charge-drawer-calendar-align-switch"
          onChange={(_event, checked) => {
            field.onChange(checked);
            const contractProRata = checked || proRataSetting !== PRO_RATA_SETTINGS.DISABLED;
            setValue(`${fieldNamePrefix}.${productIndex}.proRata`, contractProRata, { shouldDirty: true });
            setValue(`${fieldNamePrefix}.${productIndex}.isCalendarAlignedOverridden`, true);
          }}
        />
      )}
    />
  );
};
